// 4. Document Linking and Document Folder Structure
// Single source of truth for the matter document folder structure, shared between the
// Documents tab (MatterDetailPage.js) and every document-linking picker (DocumentPicker.js)
// across the system, so the folder list/order/labels never drift apart between the two.

export const DEFAULT_FOLDERS = [
  'Account Only Department',
  'Appointed Certificates',
  'Assets',
  'Assets/Immovable Assets',
  'Assets/Movable Assets',
  'Bond & Undertaking',
  'Claim Documents',
  'Court Documents',
  'Creditors',
  'Debtors',
  'Enquiries & Litigation',
  'Email Correspondence',
  'Estate Bank Account',
  'Estate Bank Account/Bank Statements',
  'First Letters',
  'Insolvent, Director & Member Correspondence',
  'Joint Correspondence',
  'L&D Account',
  'L&D Extension',
  'Master’s Correspondence',
  'Meetings',
  'Meetings/First Meeting',
  'Meetings/Second Meeting',
  'Meetings/General & Special Meeting',
  'Payments & Invoices',
  'Requisitions',
  'Release',
  'Searches',
  'Taxed Bill of Cost',
];

// Builds a nested { name, path, children: [] } tree from a flat list of "A/B/C" paths -
// identical logic to the Documents tab's own buildTree(), factored out so every folder
// picker in the system renders the exact same structure.
export const buildFolderTree = (paths) => {
  const root = { children: [] };
  [...paths].sort().forEach((path) => {
    let currentLevel = root;
    path.split('/').forEach((part) => {
      let node = currentLevel.children.find((c) => c.name === part);
      if (!node) {
        const parentPath = currentLevel.path || '';
        const currentPath = parentPath ? `${parentPath}/${part}` : part;
        node = { name: part, path: currentPath, children: [] };
        currentLevel.children.push(node);
      }
      currentLevel = node;
    });
  });
  return root.children;
};

// Flattens the folder list into a display-ready, indented, depth-sorted array for use in a
// plain <Select>: [{ path, label, depth }]. Keeps parent folders directly above their children.
export const flattenFoldersForSelect = (paths) => {
  const tree = buildFolderTree(paths);
  const out = [];
  const walk = (nodes, depth) => {
    nodes.forEach((node) => {
      out.push({ path: node.path, label: `${'— '.repeat(depth)}${node.name}`, depth });
      walk(node.children, depth + 1);
    });
  };
  walk(tree, 0);
  return out;
};
